import {performRequest} from 'shared/utils';

import {TMenuResponse} from './menu-slice-types';

export const getMenuStructure = () => performRequest<TMenuResponse>({
    url: '/menu/table',
    method: 'GET',
});
